import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import * as Yup from "yup";
import { activityAvailabilityValidationSchema, createActivityAvailability } from "./ActivityAvailability.js";
import ActivityScoreSelector from "./ActivityScoreSelector.js";

export const PARTICIPANT_VOTING_ACTIVITY_ID = 4;

export const createParticipantVotingJson = () => ({
  availability: createActivityAvailability(),
  description: "",
  single_vote_per_user: false,
  winner_score_id: null,
});

export const participantVotingValidationSchema = (dataTable = {}) => Yup.object().shape({
  title: Yup.string().required("Campo obrigatório").max(100, "Máximo de 100 caracteres"),
  app_id: Yup.number().oneOf([PARTICIPANT_VOTING_ACTIVITY_ID]).required(),
  json: Yup.object().shape({
    availability: activityAvailabilityValidationSchema(dataTable),
    description: Yup.string().max(2000, "Máximo de 2000 caracteres"),
    single_vote_per_user: Yup.boolean().required(),
    winner_score_id: Yup.number().positive("Campo obrigatório").nullable(),
  }),
});

const ActivityVotingForm = ({
  values,
  setFieldValue,
  errors = {},
  setFieldTouched,
  touched = {},
  availableScores = [],
  availabilityFields = null,
  eventId,
  onScoresChanged,
}) => {

  return (
    <>
      <Row>
      <Form.Group as={Col} md={12} className="mb-3">
        <Form.Label>Título</Form.Label>
        <Form.Control value={values.title || ""} onChange={(event) => setFieldValue("title", event.target.value)} isInvalid={Boolean(touched.title && errors.title)} />
        <Form.Control.Feedback type="invalid">{errors.title}</Form.Control.Feedback>
      </Form.Group>
      <Form.Group as={Col} md={12} className="mb-3">
        <Form.Label>Instruções</Form.Label>
        <Form.Control as="textarea" rows={4} value={values.json?.description || ""} onChange={(event) => setFieldValue("json.description", event.target.value)} isInvalid={Boolean(touched.json?.description && errors.json?.description)} />
        <Form.Control.Feedback type="invalid">{errors.json?.description}</Form.Control.Feedback>
      </Form.Group>
      <ActivityScoreSelector
        name="json.winner_score_id"
        label="Pontuação"
        type="activity_participant_voting_winner"
        value={values.json?.winner_score_id}
        scores={availableScores}
        setFieldValue={setFieldValue}
        setFieldTouched={setFieldTouched}
        error={errors.json?.winner_score_id}
        touched={touched.json?.winner_score_id}
        eventId={eventId}
        onScoresChanged={onScoresChanged}
      />
      {availabilityFields}
      <Form.Group as={Col} md={12}>
        <Form.Check
          type="checkbox"
          label="Permitir somente um voto por participante"
          checked={values.json?.single_vote_per_user === true}
          onChange={(event) => setFieldValue("json.single_vote_per_user", event.target.checked)}
        />
      </Form.Group>
      </Row>
    </>
  );
};

export default ActivityVotingForm;
